import { call, put, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import find from 'ramda/src/find';
import isNil from 'ramda/src/isNil';
import propEq from 'ramda/src/propEq';
import queryString from 'query-string';
import AppActions from '~/actions/app';
import CompanyActions from '~/actions/company';
import { history } from '~/reducers';
import { isFileObj } from '~/services/util';
import decamelize from '~/services/decamelize';
import { COM_BLOG_CATEGORIES_STORAGE_KEY } from '~/services/constants';
import NavigationService from '~/services/NavigationService';

import xmljs from 'xml-js';

export function* getbusinessRequest(api, action) {
    try {
        const { payload, route = '' } = action;
        const options = queryString.stringify(payload);
        const response = yield api.getGetBusiness(options);

        if (response.ok) {
            yield put(CompanyActions.getbusinessSuccess(response.data.data));
            const business = find(propEq('id', payload.id), response.data.data);
            const token = yield select((state) => state.app.token);
            if (token && business?.vrs?.blog?.id) {
                yield put(CompanyActions.getbusinessblogRequest({ businessId: payload.id }, false));
            }
            if (route) yield call(NavigationService.push, route);
        } else {
            yield put(CompanyActions.getbusinessFailure());
        }
    } catch (e) {
        yield put(CompanyActions.getbusinessFailure());
    }
}

export function* postbusinessRequest(api, action) {
    try {
        const { payload } = action;
        const response = yield api.postBusinessCompany(payload);
        if (response.ok) {
            yield put(CompanyActions.postbusinessSuccess(response.data));
            const callback = { id: payload.business.id };
            yield put(CompanyActions.getbusinessRequest(callback));
        } else {
            yield put(CompanyActions.postbusinessFailure());
        }
    } catch (e) {
        yield put(CompanyActions.postbusinessFailure());
    }
}

export function* getbusinessblogRequest(api, action) {
    try {
        const { businessId, payload } = action.payload;
        const options = queryString.stringify(payload, { arrayFormat: 'bracket' });
        const response = yield api.getBusinessBlog(businessId, options);
        const query = queryString.stringify({ business_id: businessId });
        const summaryRes = yield api.getBlogSummary(query);
        if (response.ok) {
            yield put(CompanyActions.getbusinessblogSuccess({ businessId, data: { ...summaryRes.data, ...response.data } }));
        } else {
            yield put(CompanyActions.getbusinessblogFailure());
        }
    } catch (e) {
        yield put(CompanyActions.getbusinessblogFailure());
    }
}

export function* getbzcompanyRequest(api, action) {
    try {
        const { companyId, after, route } = action.payload;
        const options = `company_id=${companyId}`;
        const resBusiness = yield api.getCompanyBusiness(options);
        if (resBusiness.ok) {
            if (after) yield put({ ...after });
            if (route && route !== '') yield call(NavigationService.push, route);
            const companyData = resBusiness.data.data[0];
            yield put(CompanyActions.setbzcompanyRequest(companyData));
            yield put(CompanyActions.getbzcompanySuccess(companyData));
        } else {
            yield put(CompanyActions.getbzcompanyFailure());
        }
    } catch (e) {
        yield put(CompanyActions.getbzcompanyFailure());
    }
}

export function* savebzcompanyRequest(api, action) {
    const { payload, callback } = action;

    try {
        const res = yield api.getS3Info();

        if (isNil(payload.business.id)) {
            const hash = yield api.getGenerateHash();
            payload.business.hash = hash.data;
        }

        if (res.ok && payload.business.data?.profile?.avatar && isFileObj(payload.business.data?.profile?.avatar)) {
            const formData = new FormData();
            for (const key in res.data.inputs) {
                formData.append(key, res.data.inputs[key]);
            }
            formData.set('Content-Type', payload.business.data.profile.avatar.type);
            formData.append('key', `business/${payload.business.data.hash}/${payload.business.data.profile.avatar.name}`);
            formData.append('file', payload.business.data.profile.avatar);
            const response = yield api.fileUpload(formData);

            if (response.ok) {
                const data = xmljs.xml2json(response.data, { compact: true, ignoreDeclaration: true });
                const url = JSON.parse(data).PostResponse.Location._text;
                payload.business.data.profile.avatar = url;
            }
        }

        const saveCpRes = yield api.postBusinessCompany(payload);
        if (saveCpRes.ok) {
            yield put(CompanyActions.savebzcompanySuccess(saveCpRes.data.business));
            if (callback) yield callback(saveCpRes.data.business);
        } else {
            toast.error(`The business already exists. Visit Profile Try Again!`, {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            yield put(AppActions.modalRequest({ type: '' }));
            yield put(CompanyActions.savebzcompanyFailure());
        }
    } catch (e) {
        yield put(CompanyActions.savebzcompanyFailure());
    }
}

export function* savebusinessRequest(api, action) {
    try {
        const { data, company, route, after } = action.payload;
        const response = yield api.postBusinessCompany(data);
        if (response.ok && response.data?.status !== 'error') {
            const { business } = response.data;
            if (!data.business?.id) {
                const payload = { business_id: business.id, company_id: company.id };
                const res = yield api.postAddBusiness('vr', payload);
            }
            if (after) yield put({ ...after });
            if (route && route !== '') yield call(NavigationService.push, route);
            yield put(CompanyActions.savebusinessSuccess({ ...company, business: business }));
        } else {
            yield put(CompanyActions.savebusinessFailure());
        }
    } catch (e) {
        yield put(CompanyActions.savebusinessFailure());
    }
}

export function* getblogcategoriesRequest(api, action) {
    try {
        const response = yield api.getComBlogCategories();
        if (response.ok) {
            yield put(CompanyActions.getblogcategoriesSuccess(response.data.categories));
        } else {
            yield put(CompanyActions.getblogcategoriesFailure());
        }
    } catch (e) {
        yield put(CompanyActions.getblogcategoriesFailure());
    }
}

export function* gettopiccategoriesRequest(api, action) {
    try {
        const response = yield api.getComTopicCategories();
        if (response.ok) {
            yield put(CompanyActions.gettopiccategoriesSuccess(response.data.categories));
        } else {
            yield put(CompanyActions.gettopiccategoriesFailure());
        }
    } catch (e) {
        yield put(CompanyActions.gettopiccategoriesFailure());
    }
}

export function* getcompanyusersRequest(api, action) {
    try {
        const { companyId } = action.payload;
        const response = yield api.getCompanyUsers(companyId);
        if (response.ok) {
            yield put(CompanyActions.getcompanyusersSuccess(response.data.employees));
        } else {
            yield put(CompanyActions.getcompanyusersFailure());
        }
    } catch (e) {
        yield put(CompanyActions.getcompanyusersFailure());
    }
}

export function* postregisterbusinessuserRequest(api, action) {
    try {
        const { payload, companyId } = action;
        const response1 = yield api.postCompanyUsers(payload, companyId);
        const business = yield select((state) => state.app.modalData);
        const busId = business.after.business.id;
        const _payload = { business_id: busId, user_id: response1.data.users[0].id };
        const response2 = yield api.postAddUser(_payload);
        if (response1.ok && response2.ok) {
            yield put(CompanyActions.postregisterbusinessuserSuccess(response.data));
        } else {
            yield put(CompanyActions.postregisterbusinessuserFailure());
        }
    } catch (e) {
        yield put(CompanyActions.postregisterbusinessuserFailure());
    }
}

export function* postaddeditdepartmentsRequest(api, action) {
    try {
        const { companyId, payload, callback } = action;
        const response = yield api.postAddEditDepartments(companyId, payload);
        if (response.ok) {
            yield put(CompanyActions.postaddeditdepartmentsSuccess(response.data));
            yield put(AppActions.postmulticompanydataRequest());
            if (callback) yield callback(response.data);
        } else {
            yield put(CompanyActions.postaddeditdepartmentsFailure());
        }
    } catch (e) {
        yield put(CompanyActions.postaddeditdepartmentsFailure());
    }
}

export function* postdeletedepartmentRequest(api, action) {
    try {
        const { businessId, companyId, departmentId } = action;
        const response = yield api.postDeleteDepartment(companyId, departmentId);
        if (response.ok) {
            yield put(CompanyActions.postdeletedepartmentSuccess({ businessId, departmentId }));
        } else {
            yield put(CompanyActions.postdeletedepartmentFailure());
        }
    } catch (e) {
        yield put(CompanyActions.postdeletedepartmentFailure());
    }
}

export function* postaddeditteamsRequest(api, action) {
    try {
        const { companyId, payload } = action;
        const response = yield api.postAddEditTeams(companyId, payload);
        if (response.ok) {
            yield put(CompanyActions.postaddeditteamsSuccess(response.data));
            toast.success(`Saved successfully!`, {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
        } else {
            yield put(CompanyActions.postaddeditteamsFailure());
        }
    } catch (e) {
        yield put(CompanyActions.postaddeditteamsFailure());
    }
}

export function* postdeleteteamRequest(api, action) {
    try {
        const { companyId, teamId } = action;
        const response = yield api.postDeleteTeam(companyId, teamId);

        if (response.ok) {
            yield put(CompanyActions.postdeleteteamSuccess(response.data));
        } else {
            yield put(CompanyActions.postdeleteteamFailure());
        }
    } catch (e) {
        yield put(CompanyActions.postdeleteteamFailure());
    }
}

export function* postsavejobrolesRequest(api, action) {
    try {
        const { companyId, payload } = action;
        const response = yield api.postSaveJobRoles(companyId, payload);
        if (response.ok) {
            yield put(CompanyActions.postsavejobrolesSuccess(response.data));
        } else {
            yield put(CompanyActions.postsavejobrolesFailure());
        }
    } catch (e) {
        yield put(CompanyActions.postsavejobrolesFailure());
    }
}

export function* postsavehcmcompanyRequest(api, action) {
    try {
        const { payload } = action;
        const response = yield api.postSaveHCMCompany(payload);
        if (response.ok) {
            yield put(AppActions.getcompaniesRequest());
            yield put(CompanyActions.postsavehcmcompanySuccess(response.data));
        } else {
            yield put(CompanyActions.postsavehcmcompanyFailure());
        }
    } catch (e) {
        yield put(CompanyActions.postsavehcmcompanyFailure());
    }
}

export function* getminimalcompanyemployeesRequest(api, action) {
    try {
        const { companyId, cacheBust = 0 } = action;
        const response = yield api.getMinimalCompanyEmployees(companyId, cacheBust);
        if (response.ok) {
            yield put(CompanyActions.getminimalcompanyemployeesSuccess(response.data.employees, cacheBust));
        } else {
            yield put(CompanyActions.getminimalcompanyemployeesFailure());
        }
    } catch (e) {
        yield put(CompanyActions.getminimalcompanyemployeesFailure());
    }
}

export function* postcompanyfollowRequest(api, action) {
    try {
        const { data, after, route } = action.payload;
        const response = yield api.postFollowRequest(data);
        if (response.ok) {
            if (after) yield put({ ...after });
            if (route && route !== '') yield call(NavigationService.push, route);
            yield put(CompanyActions.postcompanyfollowSuccess());
            toast.success('Request sent', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
        } else {
            yield put(CompanyActions.postcompanyfollowFailure());
            toast.error(response.data?.message || 'Request failed.', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
        }
    } catch (e) {
        yield put(CompanyActions.postcompanyfollowFailure());
    }
}

export function* postcompanyconnectRequest(api, action) {
    try {
        const { data, after, route } = action.payload;
        const response = yield api.postEntityConnection(data);
        if (response.ok) {
            if (after) yield put({ ...after });
            if (route && route !== '') yield call(NavigationService.push, route);
            yield put(CompanyActions.postcompanyconnectSuccess());
            toast.success('Request sent', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
        } else {
            yield put(CompanyActions.postcompanyconnectFailure());
            toast.error('Request failed.', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
        }
    } catch (e) {
        yield put(CompanyActions.postcompanyconnectFailure());
    }
}

export function* getcompanyconnectionsRequest(api, action) {
    try {
        const { payload } = action;
        const options = queryString.stringify(payload);
        const response = yield api.getEntityConnections(options);
        if (response.ok) {
            yield put(CompanyActions.getcompanyconnectionsSuccess({ companyId: payload.company_id, connections: response.data }));
        } else {
            yield put(CompanyActions.getcompanyconnectionsFailure());
        }
    } catch (e) {
        yield put(CompanyActions.getcompanyconnectionsFailure());
    }
}

export function* getusersubscriptionsRequest(api, action) {
    try {
        const { userId } = action;
        const response = yield api.getUserSubscriptions(userId);
        if (response.ok) {
            yield put(CompanyActions.getusersubscriptionsSuccess(response.data));
        } else {
            yield put(CompanyActions.getusersubscriptionsFailure());
        }
    } catch (e) {
        yield put(CompanyActions.getusersubscriptionsFailure());
    }
}

export function* getsubscriptionreportsRequest(api, action) {
    try {
        const response = yield api.getSubscriptionReports();
        if (response.ok) {
            yield put(CompanyActions.getsubscriptionreportsSuccess(response.data));
        } else {
            yield put(CompanyActions.getsubscriptionreportsFailure());
        }
    } catch (e) {
        yield put(CompanyActions.getsubscriptionreportsFailure());
    }
}

export function* getsubscriptionfrequenciesRequest(api, action) {
    try {
        const response = yield api.getSubscriptionFrequencies();
        if (response.ok) {
            yield put(CompanyActions.getsubscriptionfrequenciesSuccess());
        } else {
            yield put(CompanyActions.getsubscriptionfrequenciesFailure());
        }
    } catch (e) {
        yield put(CompanyActions.getsubscriptionfrequenciesFailure());
    }
}

export function* postaddsubscriptionRequest(api, action) {
    try {
        const { payload } = action;
        const response = yield api.postAddSubscription(payload);
        if (response.ok) {
            toast.success(response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            yield put(CompanyActions.postaddsubscriptionSuccess());
        } else {
            toast.error(response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            yield put(CompanyActions.postaddsubscriptionFailure());
        }
    } catch (e) {
        yield put(CompanyActions.postaddsubscriptionFailure());
    }
}

export function* postsavesubscriptionRequest(api, action) {
    try {
        const { payload } = action;
        const response = yield api.postSaveSubscription(payload);
        if (response.ok) {
            toast.success(response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            yield put(CompanyActions.postsavesubscriptionSuccess());
        } else {
            toast.error(response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            yield put(CompanyActions.postsavesubscriptionFailure());
        }
    } catch (e) {
        yield put(CompanyActions.postsavesubscriptionFailure());
    }
}
